export default __webpack_public_path__ + "static/media/background-header.48fb38f9.svg";